import { render, staticRenderFns } from "./PhoneInputV1Properties.vue?vue&type=template&id=d27210fe&"
import script from "./PhoneInputV1Properties.vue?vue&type=script&lang=js&"
export * from "./PhoneInputV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports